export function updateArrowPosition(carousel, elSelector = '.boost-pfs-filter-product-item-image') {
    const arrows = carousel.root.querySelectorAll('.splide__arrow');
    const firstSlide = carousel.Components.Elements.slides[0];
    if (firstSlide) {
        const slideImg = firstSlide.querySelector(elSelector);
        if (slideImg) {
            const imgHeight = slideImg.offsetHeight;
            if (imgHeight === 0)
                return;
            arrows.forEach(arrow => {
                arrow.style.top = `${imgHeight / 2}px`;
            });
        }
    }
}
